import {
  ConnectionBridgeBaseFragment,
  IntegrationConfigurationFragment,
  useCreateConnectionBridgeMutation,
} from "@/apollo/types";

type ConnectionOptions = {
  onSuccess?: (connectionBridge: ConnectionBridgeBaseFragment) => void;
  onError?: (error: Error) => void;
};

export function useCreateConnectionBridge(options: ConnectionOptions) {
  const [createConnectionBridge, { loading, data }] =
    useCreateConnectionBridgeMutation({
      awaitRefetchQueries: true,
      onCompleted: async (data) => {
        options.onSuccess?.(data.createConnectionBridge);
      },
      onError: (e) => {
        options.onError?.(e);
      },
    });

  return {
    loading: loading,
    data,
    createConnectionBridge: async (
      integration: IntegrationConfigurationFragment,
      label: string,
      connectionId?: string,
    ) => {
      return createConnectionBridge({
        variables: {
          integrationId: integration.id,
          label,
          connectionId,
        },
      });
    },
  };
}
